export const RolesEnums = {
    SUPER_ADMIN: 'superadmin',
    FREE_USER: 'L1',
    PREMIUM_USER: 'L2',
    ON_PREMISE_USER: 'L3'
}
